import loading from './loading.vue'

export default {
    install (Vue) {
        Vue.component('Loading', loading)
    }
}